import IndLogo from "../assest/img/kenyalanding/indiapropexpologo.png";
import IntroLogo from "../assest/img/kenyalanding/Introductions-logo.png";
import ToiLogo from "../assest/img/kenyalanding/toi.png";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import VisitorRegistrationFormIPE from "../Components/IPEForm/VisitorRegistrationFormIPE";
export default function PrivacyPolicyKenya() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Open modal after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      handleShow();
    }, 2000); // 5 seconds delay

    return () => clearTimeout(timer); // Cleanup timeout on component unmount
  }, []);
  return (
    <>
      <Helmet>
        <title>Privacy Policy | India Prop Expo </title>
        <meta
          name="description"
          content="Protecting your privacy is our priority. Discover how Privacy Policy collects and safeguards your personal information in our Privacy Notice. "
        />
        <meta
          property="og:title"
          content="        Privacy Policy | India Prop Expo   </title>
 "
        />
        <meta
          property="og:description"
          content="Protecting your privacy is our priority. Discover how Privacy Policy collects and safeguards your personal information in our Privacy Notice. "
        />
        <meta
          name="keywords"
          content="Privacy Policy, India Property Expo, real estate exhibition India, property fair India, Indian real estate, real estate expo 2025, property investment India, property developers India, India prop expo 2025, India prop expo in hongkong"
        />
        <meta
          property="og:url"
          content=" https://indiapropexpo.com/privacy-policy-kenya"
        />
        <link
          rel="canonical"
          href="https://indiapropexpo.com/privacy-policy-kenya"
        />
        <meta
          property="og:image"
          content="https://indiapropexpo.com/static/media/indiapropexpologo.bb5ef163d51e392164ce.png

    "
        />
        <meta
          name="twitter:title"
          content="        Privacy Policy | India Prop Expo   </title>
 "
        />
        <meta
          name="twitter:description"
          content="Protecting your privacy is our priority. Discover how Privacy Policy collects and safeguards your personal information in our Privacy Notice. 
    "
        />
        <meta
          name="twitter:image"
          content="https://indiapropexpo.com/static/media/indiapropexpologo.bb5ef163d51e392164ce.png

    "
        />
      </Helmet>
      <section id="navbar" className="sticky-top shadow-sm">
        <nav className="navbar navbar-expand-md navbar-white bg-white">
          <div className="container-fluid">
            <div className=" p-0">
              <a className="navbar-brand m-0 main-logo" href="./">
                <img src={IndLogo} alt="India Realty Show Logo" />
                <p>Abu Dhabi</p>
              </a>
            </div>
            <div className=" btn-register" onClick={handleShow}>
              Free Visitor Registration
            </div>
            {/* <div className=" p-0">
              <a className="navbar-brand m-0" href="./">
                <img src={ToiLogo} alt="Times of India Logo" />
              </a>
            </div> */}
          </div>
        </nav>
      </section>
      <section>
        <div className="container-fluid privacy-policy-page my-5">
          <div className="row">
            <div className="col-12">
              <h1 className="text-center">Privacy Policy</h1>
              <p>
                India Property Expo privacy policy explains how we collect, use,
                and protect your personal information when you attend our
                property exhibition events.
              </p>
              <b>What Information We Collect</b>
              <p>We collect the following types of personal information:</p>
              <ul>
                <li>
                  <b>Contact Information:</b> Your name, email address, phone
                  number, and address.
                </li>
                <li>
                  <b>Registration Information:</b> Information you provide when
                  signing up for an event.
                </li>
                <li>
                  <b>Feedback and Communication:</b> Your comments, questions,
                  and other correspondence with us.
                </li>
              </ul>
              <b>How We Use Your Information</b>
              <p>We use your information to:</p>
              <ul>
                <li>Organize and manage your participation in our events.</li>
                <li>Provide you with updates and event invitations.</li>
                <li>Improve our services based on your feedback.</li>
                <li>Respond to your inquiries.</li>
              </ul>
              <b>Sharing Your Information</b>
              <p>We may share your information with:</p>
              <ul>
                <li>
                  <b>Event Partners:</b> To give you information about
                  properties and services.
                </li>
                <li>
                  <b>Service Providers:</b> Who help us manage our events and
                  services.
                </li>
                <li>
                  <b>Authorities:</b> If required by law.
                </li>
              </ul>
              <b>Data Retention</b>
              <p>
                We keep your information as long as needed for our services and
                to meet legal requirements.
              </p>
              <b>Security</b>
              <p>
                We take steps to protect your information from unauthorized
                access or misuse.
              </p>
              <b>Changes to This Privacy Policy</b>
              <p>
                We may update this policy. Any changes will be posted on our
                website.
              </p>
              <b>Contact Us</b>
              <p>
                If you have questions about this privacy policy, please contact
                us at:
              </p>
              <ul>
                <li>
                  Email:{" "}
                  <a
                    href="mailto:sakalvisitors@gmail.com"
                    className="text-decoration-none text-dark">
                    sakalvisitors@gmail.com
                  </a>
                </li>
                <li>
                  Phone:{" "}
                  <a
                    href="tel:+917880038782"
                    className="text-decoration-none text-dark">
                    +91 78800 38782
                  </a>
                </li>
                <li>
                  Address: <strong>Royal Rose Hotel Abu Dhabi.</strong>
                  <br />
                  1025 Sheikh Zayed The 1st, Al Markaziyah District, Abu Dhabi,
                  UAE.
                </li>
              </ul>
              <p>
                Thank you for being part of India Property Expo. We value your
                privacy and strive to protect your information.
              </p>
            </div>
          </div>
        </div>
      </section>
      <footer className="bg-light py-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 col-lg-2 mb-4 mb-lg-0">
              <img
                src={IndLogo}
                className="img-fluid"
                alt="India Realty Show Logo"
              />
            </div>
            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0 ps-lg-4">
              <p className="mb-0">
                <strong>Royal Rose Hotel Abu Dhabi.</strong>
                <br />
                1025 Sheikh Zayed The 1st, Al Markaziyah District, Abu Dhabi,
                UAE.
              </p>

              <a
                href="https://www.google.com/maps/place/Royal+Rose+Abu+Dhabi,+a+Curio+Collection+by+Hilton+Affiliated+Hotel/@24.493274,54.372932,793m/data=!3m1!1e3!4m21!1m11!3m10!1s0x3e5e65e6cf3259b5:0xb3a7cf18a3a1c878!2sRoyal+Rose+Abu+Dhabi,+a+Curio+Collection+by+Hilton+Affiliated+Hotel!5m2!4m1!1i2!8m2!3d24.493274!4d54.372932!10e7!16s%2Fg%2F1pv610ylw!3m8!1s0x3e5e65e6cf3259b5:0xb3a7cf18a3a1c878!5m2!4m1!1i2!8m2!3d24.493274!4d54.372932!16s%2Fg%2F1pv610ylw?entry=ttu&g_ep=EgoyMDI1MTEwOS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer">
                <i className="fa-solid fa-location-dot"></i> Click here for
                direction
              </a>
            </div>
            <div className="col-md-6 col-lg-3 ps-lg-5">
              <ul className="footer-contact-links">
                <li>
                  <a href="tel:+919322228089">
                    <i className="fa-solid fa-phone"></i> +91 93222 28089
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/+919322228089">
                    <i className="fa-brands fa-whatsapp"></i> +91 93222 28089
                  </a>
                </li>
                <li>
                  <a href="mailto:sakalvisitors@gmail.com">
                    <i className="fa-solid fa-envelope"></i>
                    <span>sakalvisitors@gmail.com</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-2">
              <b>Follow Us On</b>
              <ul className="footer-contact-links mt-2">
                <li>
                  <a
                    href="https://www.facebook.com/nriniveshpropertyexpo/"
                    target="_blank">
                    <i className="fa-brands fa-facebook"></i> Facebook
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/indiapropertyexpointroductions/"
                    target="_blank">
                    <i className="fa-brands fa-instagram"></i> Instagram
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-2 mb-4 mb-lg-0">
              <b className="d-block">Organized By</b>
              <img
                src={IntroLogo}
                className="img-fluid mt-2"
                alt="Introduction Trade Shows Logo"
              />
            </div>
            <div className="col-lg-8 mx-auto text-center">
              <p className="footer-text">
                Note that only Resident Indians, Non Resident Indians (NRI) ,
                People of Indian Origin ( PIO), Overseas Citizen of India (OCI)
                & Resident Indians living in India or Abroad are Allowed to buy
                properties in India . This site is not a part of the Facebook
                website or Facebook Inc . Additionally this site is not endorsed
                by Facebook or FACEBOOK, Inc. in any way.
              </p>
            </div>
          </div>
        </div>
      </footer>
      <div className="container-fluid px-lg-4 bg-dark py-2">
        <div className="row">
          <div className="col-md-6 text-center text-lg-start text-white">
            <p className="cursive-font mb-0 pt-1">
              Come visit and buy your dream property
            </p>
          </div>
          <div className="col-md-6 text-white text-center text-lg-end">
            <a
              href="/privacy-policy.html"
              className="w-auto mt-2 d-inline-block text-white text-decoration-none">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="model-cross-visitor">
          <Modal.Title>Free Visitor Registration</Modal.Title>
        </Modal.Header>
        <Modal.Body className="model-cross-visitor p-0 ipe-form-modal">
          {/* <iframe
            src="https://indiapropexpo.com/visitorregistrationipe"
            className="iframe-model"
            frameborder="0"></iframe> */}
          <VisitorRegistrationFormIPE />
        </Modal.Body>
      </Modal>
    </>
  );
}
